import StyledLink from '../StyledLink'
import {
  CONTROLLER,
  REQUIREMENTS
} from '../routes'
import type { Props } from '../types'

// TODO ETD-2870 will switch to requirement import page after the page is ready
const LinkToRequirements = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + CONTROLLER + '/' + REQUIREMENTS}
  >
    {children}
  </StyledLink>

export default LinkToRequirements
